import { FundBasketLayout } from "@funds/pages/fund-basket-layout";
import { createFileRoute } from "@tanstack/react-router";
import { fundBasketQueryOptions } from "creso-core/hooks";

export const Route = createFileRoute("/(auth)/_headed/funds/basket/$basket_id")(
  {
    params: {
      parse: (params) => ({ basket_id: Number(params.basket_id) }),
    },
    loader: async ({ context, params }) => {
      const { queryClient } = context;

      const basket = await queryClient.ensureQueryData(
        fundBasketQueryOptions(params.basket_id)
      );

      return { basket };
    },
    component: FundBasketLayout,
  }
);
